<template>
 <div class="container container-narrow">
  <div class="welcome-flow-container">
   <div class="row align-items-center">

    <div class="col-12 mt-5">
     <div class="text-center">
      <img src="~@/assets/excelerate-logo.png" alt="Excelerate" title="Excelerate" class="logo">
     </div>
     <div class="widget mb-3 mt-4">
      <div class="widget-splash splash-line"></div>
      <div class="widget-body">
       <h4>Reset Password</h4>
       <form @submit.prevent="resetPassword">
        <div class="form-group">
         <label>New Password</label>
         <input type="password" v-model="password" @keyup="clearStatus" name="password"
          class="form-control form-control-lg" placeholder="Minimum 6 characters" autofocus required>
        </div>
        <div class="form-group">
         <label>Confirm new Password</label>
         <input type="password" v-model="confirmPassword" @keyup="clearStatus" name="confirmPassword" :class="confirmPassword.length > 0 &&
          confirmPassword !== password
          ? 'form-control  form-control-lg is-invalid'
          : 'form-control  form-control-lg'
          " placeholder="Confirm password" autofocus required>
        </div>
        <div class="alert alert-success" v-if="successMessage">
         {{ successMessage }}
        </div>
        <div class="alert alert-danger" v-if="failureMessage">
         {{ failureMessage }}
        </div>
        <div class="form-group">
          <button class="btn btn-primary btn-block btn-lg Explorer-CreateStudentProfile-Next" :disabled="isUpdating">
           <span v-if="isUpdating" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
           <span v-else>
            <!-- {{ pageContent && pageContent.formHeader ? pageContent.formHeader : 'Next' }}  -->
            Reset password
           </span></button>
        </div>
       </form>
      </div>
     </div><!-- /widget -->
    </div>
   </div>
  </div>
 </div>
</template>

<script>
import apiInstance from '../../axios/axios';
// import firebase from 'firebase/app';
export default {
 name: 'SignInForm',


 data: function () {
  return {
   password: '', //123456
   confirmPassword: '',
   verification_code: this.$route.params.id,
   failureMessage: null,
   successMessage: null,
   isUpdating: false,
  }
 },
 mounted(){
  if(localStorage.getItem('auth-token')) this.$router.push('/') // a simple guard inplace
 },
 metaInfo: {
  title: "Forgot password – Excelerate profile | Excelerate.dk",
  meta: [
   { name: 'description', content: 'Forgot your password for your Excelerate profile? Go to Excelerate forgot password page and receive a new password in your email.' },
   { property: 'og:title', content: "Forgot password – Excelerate profile | Excelerate.dk" },
   { property: 'og:description', content: "Forgot your password for your Excelerate profile? Go to Excelerate forgot password page and receive a new password in your email." },
  ]
 },
 methods: {
  clearStatus() {
   this.failureMessage = null
   this.successMessage = null
  },
  resetPassword() {
    const vm = this
   this.successMessage = null
   this.failureMessage = null
   if (this.password === this.confirmPassword) {
    if(this.password.length < 6) {
     return this.failureMessage = "Password must be at least 6 characters";
    }
    this.isUpdating = true
    apiInstance.post('forget-password', { password: this.password, verification_code: this.verification_code }).then(response => {
     this.isUpdating = false
     let seconds = 3
     this.successMessage = `${response.data.message}, redirecting you in ${seconds} seconds`
     setInterval(() => {
      seconds = seconds -1
      this.successMessage = `${response.data.message}, redirecting you in ${seconds} seconds`
     }, 1000);
     setTimeout(() => {
      vm.$router.push('/signin')
     }, 3500);
    }).catch(error => {
     this.isUpdating = false
     this.failureMessage = error.response.data.message
    })
   } else {
    this.failureMessage = "Passwords do not match";
   }
  },
  getUserByIdFromFirebase() {
   this.$store.dispatch('syncUserByIdFromFirebaseAuth');
  },
  signOut() {
   this.$store.dispatch('signOutAction');
  },

 }
}
</script>